import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

export default function EffectControl( { attributes, setAttributes } ) {
	const desktopSlides = attributes.slides?.desktop ?? 3;

	if ( desktopSlides < 3 ) {
		return null;
	}

	const isCenter = attributes.effect === 'center';

	return (
		<>
			<SelectControl
				__nextHasNoMarginBottom
				label={ __( 'Effect', 'brandy-blocks' ) }
				value={ attributes.effect ?? 'default' }
				options={ [
					{
						label: __( 'Default', 'brandy-blocks' ),
						value: 'default',
					},
					{
						label: __( 'Center Mode', 'brandy-blocks' ),
						value: 'center',
					},
				] }
				onChange={ ( v ) => setAttributes( { effect: v } ) }
			/>
			{ isCenter && (
				<>
					<SelectControl
						__nextHasNoMarginBottom
						label={ __( 'Center style', 'brandy-blocks' ) }
						value={ attributes.spotlightStyle ?? 'fade' }
						options={ [
							{
								label: __(
									'Fade + Scale',
									'brandy-blocks'
								),
								value: 'fade-scale',
							},
							{
								label: __(
									'Fade',
									'brandy-blocks'
								),
								value: 'fade',
							},
							{
								label: __(
									'Scale',
									'brandy-blocks'
								),
								value: 'scale',
							},
						] }
						onChange={ ( v ) =>
							setAttributes( { spotlightStyle: v } )
						}
					/>
					{ ( attributes.spotlightStyle === 'fade-scale' ||
						attributes.spotlightStyle === 'scale' ) && (
						<SelectControl
							__nextHasNoMarginBottom
							label={ __(
								'Scale intensity',
								'brandy-blocks'
							) }
							value={
								attributes.spotlightScale ?? 'medium'
							}
							options={ [
								{
									label: __(
										'Subtle',
										'brandy-blocks'
									),
									value: 'subtle',
								},
								{
									label: __(
										'Medium',
										'brandy-blocks'
									),
									value: 'medium',
								},
								{
									label: __(
										'Bold',
										'brandy-blocks'
									),
									value: 'bold',
								},
							] }
							onChange={ ( v ) =>
								setAttributes( {
									spotlightScale: v,
								} )
							}
						/>
					) }
				</>
			) }
		</>
	);
}
